module.exports = __webpack_public_path__ + "2b87c9adb5a6a2b2759bc256cba4cf2d.png";